export default "__VITE_ASSET__Bf$8w1f2__"